export default __webpack_public_path__ + "assets/images/46daf8ed27e4e743798da146430e35ae.png";